<template>
  <div>
    <div class="row mb-2 mb-md-5 pb-3 flex-nowrap overflow-auto">
      <div
        v-for="(tab, index) in tabList"
        :key="index"
        class="col-10 col-sm-7 col-md-5 col-lg d-flex"
      >
        <div
          class="navigation-card p-2 p-md-3 rounded-lg"
          :class="{ active: isActive(index) }"
          @mouseover="select(index)"
        >
          <div :class="`tab-icon icon i-5 icon-${tab.icon} mb-2`"></div>
          <p class="h6 mb-0 tab-title">{{ tab.title }}</p>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreTabs",
  data() {
    return {
      activeTabIndex: 0,
      tabList: [],
    };
  },
  mounted() {
    this.select(0);
    this.activeTabIndex = this.getInitialActiveTab();
    this.$root.$on("select-tab", index => this.select(index));
  },
  methods: {
    isActive(index) {
      return this.activeTabIndex === index;
    },
    select(index) {
      const tab = this.tabList[index];
      if (!tab.isDisabled) {
        this.activeTabIndex = index;
      }
      this.$emit("changed", tab);
    },
    getInitialActiveTab() {
      const index = this.tabList.findIndex(tab => tab.active);
      return index === -1 ? 0 : index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.tab-content {
  min-height: 400px;
  position: relative;
}

.tab-icon {
  color: $gray-700;
}

.tab-title {
  color: $gray-900;
  word-break: break-word;
}

.navigation-card {
  border: $width-border-thick solid $white;
  background: $white;
  text-align: center;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  box-shadow: $box-shadow-sm;

  @include hover-states {
    box-shadow: $box-shadow-sm-hover;
  }
}

.active {
  border-color: $gray-100;
  box-shadow: $box-shadow-sm-hover;
}
</style>
